import { type GetPositionFn } from '..'

export const getFullscreenPosition: GetPositionFn<'fullscreen'> = (targetOptions, context) => {
  return {
    elementBounding: {
      top: 0,
      left: 0,
      width: context.windowSize.width.value,
      height: context.windowSize.height.value
    },
    containerStyle: {
      'z-index': 10000
    }
  }
}
